import { autoinject, bindable } from 'aurelia-framework';
import { NodeModel } from '../../../models/node-model';
import { CostCenterService, ICostCenterAM } from '../cost-centers/cost-center-api';
import { OrganizationalUnitService } from './organizational-unit-service';

@autoinject
export class OrganizationalUnitManagement {
	@bindable organizationId: string;	
	@bindable searchTerm: string;	

	selectedNode: NodeModel;

	constructor(
		private organizationalUnitService: OrganizationalUnitService,
		private costCenterService: CostCenterService) {
	}

	private get organizationalUnitId() {
		return this.selectedNode != null && this.selectedNode.nodeType === 'OrganizationalUnit'
			? this.selectedNode.id
			: null;
	}

	addCostCenter(costCenter: ICostCenterAM): Promise<Response> {
		const unitId = this.organizationalUnitId;
		if (!unitId) {
			return Promise.resolve(null);
		}
		return this.costCenterService.addCostCenter(unitId, costCenter)
			.then(response => {
				if (response.status === 200) {
					this.organizationalUnitService.refreshOrganizationalUnits(this.organizationId, true);
				}
				return response;
			});
	}

	updateCostCenter(costCenter: ICostCenterAM): Promise<Response> {
		return this.costCenterService.updateCostCenter(costCenter)
			.then(response => {
				if (response.status === 200) {
					this.organizationalUnitService.refreshOrganizationalUnits(this.organizationId, true);
				}
				return response;
			});
	}

	async removeCostCenter(costCenter: ICostCenterAM) {
		const response = await this.costCenterService.removeCostCenter(costCenter);
		this.organizationalUnitService.refreshOrganizationalUnits(this.organizationId, true);
		return response;
	}
}
